/**
 * Хук для получения логотипа школы
 * Всегда возвращает дефолтный логотип /logo.png
 */
export function useSchoolLogo(): string {
  return '/logo.png'
}

